import { FC } from "react";

import slugify from "react-slugify";

interface CheckBoxProps {
  /**
   * Specifies whether the checkbox is checked by default.
   */
  defaultChecked?: boolean;

  /**
   * The ID of the checkbox element.
   */
  id?: string;

  /**
   * The label text for the checkbox.
   */
  label: string;

  /**
   * Specifies whether the checkbox is required.
   */
  required?: boolean;
}

export const CheckBox: FC<CheckBoxProps> = ({
  defaultChecked,
  id,
  label,
  required = false,
}) => {
  const renderedId = id || slugify(label);

  return (
    <label
      className="flex flex-row items-center gap-4 text-base xl:text-xl"
      htmlFor={renderedId}
      key={renderedId}
    >
      <input
        className="size-8 focus-visible:outline focus-visible:outline-4 focus-visible:outline-darkerblue dark:focus-visible:outline-white"
        defaultChecked={defaultChecked}
        id={renderedId}
        name={renderedId}
        required={required}
        type="checkbox"
      />
      {label}
    </label>
  );
};

export default CheckBox;
